export default __webpack_public_path__ + "751c397a5dac2b15f01750b29745bdf8.svg";